import ReleaseNotesList from '@ReleaseNotes/views/ReleaseNotesList.vue';
import JiraVersionPicker from '@ReleaseNotes/views/JiraVersionPicker.vue';
import ReleaseDetail from '@ReleaseNotes/views/ReleaseDetail.vue';
import ReleaseNotesSettings from '@ReleaseNotes/views/ReleaseNotesSettings.vue';
import WhatsNew from '@ReleaseNotes/views/tenant/WhatsNew.vue';
import ReleaseDetailPublic from '@ReleaseNotes/views/tenant/ReleaseDetailPublic.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-release-notes',
    name: 'release-notes',
    component: ReleaseNotesList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Release Notes',
      permissions: [permissions.ReleaseNotes.View],
    },
  },
  {
    path: '/manage-release-notes/new',
    name: 'release-notes-new',
    component: JiraVersionPicker,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'New Release',
      permissions: [permissions.ReleaseNotes.Edit],
    },
  },
  {
    path: '/manage-release-notes/settings',
    name: 'release-notes-settings',
    component: ReleaseNotesSettings,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Release Notes Settings',
      permissions: [permissions.ReleaseNotes.Settings],
    },
  },
  {
    path: '/manage-release-notes/:id',
    name: 'release-notes-detail',
    component: ReleaseDetail,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Release',
      permissions: [permissions.ReleaseNotes.View],
    },
  },
  {
    path: '/releases',
    name: 'releases',
    component: WhatsNew,
    meta: { requiresAuth: true, layout: 'accountLayout', title: "What's New" },
  },
  {
    path: '/releases/:slug',
    name: 'release-detail-public',
    component: ReleaseDetailPublic,
    props: true,
    meta: { requiresAuth: true, layout: 'accountLayout', title: 'Release' },
  },
];
